import { DateTime } from "luxon"
import { useField } from "formik"
import { Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../../../modules/localization/components/AppLocalized"
import { SelectedPriceListItem } from "../../../../../createOrderTypes"
import { CreateUpdateDeliveryFormValues } from "../../CreateUpdateDeliveryTimePopover"
import { DeliveryTimeFields } from "./DeliveryTimeFields"
import { FormikSubmitButton } from "../../../../../../forms/Formik"
import { useDeliveryTimeLimits } from "./useDeliveryTimeLimits"
import { DeliveryTimeDay } from "../../../../form/formTypes"

type PopoverDeliveryTimeFormContentProps = Readonly<{
    priceList: SelectedPriceListItem
    allowedWeekdays: number[]
    eventStartTime: DateTime | null
    closingDates: string[]
    openingHours?: DeliveryTimeDay[]
    maxAllowedDeliveries: number
    handlePopoverClose: () => void
    allowPastDates: boolean
}>

export function PopoverDeliveryTimeFormContent({
    priceList,
    allowedWeekdays,
    eventStartTime,
    closingDates,
    openingHours = [],
    maxAllowedDeliveries,
    handlePopoverClose,
    allowPastDates,
}: PopoverDeliveryTimeFormContentProps) {
    const [{ value: deliveryDate }] = useField<CreateUpdateDeliveryFormValues["deliveryDate"]>("deliveryDate")

    // The only genuinely blocking case: the delivery date is today and the shop has already
    // closed, so no valid time is left. Picking another date reopens the form.
    const { noSlotsForDate: isDeliveryBlocked } = useDeliveryTimeLimits(deliveryDate, openingHours)

    return (
        <Stack gap="2rem">
            <Stack gap="1.25rem">
                <LocalizedStrict id="create-order-delivery-times-add-delivery-time-title">
                    <Typography variant="h6">Add delivery time</Typography>
                </LocalizedStrict>

                <DeliveryTimeFields
                    priceList={priceList}
                    allowedWeekdays={allowedWeekdays}
                    eventStartTime={eventStartTime}
                    closingDates={closingDates}
                    openingHours={openingHours}
                    maxAllowedDeliveries={maxAllowedDeliveries}
                    allowPastDates={allowPastDates}
                />
            </Stack>
            <Stack flexDirection="row" justifyContent="center">
                <LocalizedStrict
                    id={
                        isDeliveryBlocked
                            ? "create-order-delivery-times-dialog-close-button"
                            : "create-order-delivery-times-dialog-submit-button"
                    }
                >
                    <FormikSubmitButton
                        type={isDeliveryBlocked ? "button" : "submit"}
                        fullWidth={false}
                        onClick={() => (isDeliveryBlocked ? handlePopoverClose() : {})}
                    >
                        {isDeliveryBlocked ? "Ok" : "Confirm"}
                    </FormikSubmitButton>
                </LocalizedStrict>
            </Stack>
        </Stack>
    )
}
